<template>
    <div class="billing-center-box">
        <van-nav-bar title="管理员" />

        <div class="store-admin-content">
            <div class="hhk-item df-csb" v-for="(item, index) in adminList" :key="index" @click="onGoEditPage(item)">
                <div class="left">
                    <div class="df-c">
                        <div class="hhk-item-name mr20">{{ item.uname }}</div>
                        <div>{{ item.phone }}</div>
                    </div>
                    <div>{{ item.roleType | roleType }}</div>
                </div>
                <div class="right">
                    <span class="text"> （{{ item.status === 0 ? '确认中' : '已确认' }}） </span>
                    <van-icon name="arrow" />
                </div>
            </div>
        </div>
        <div class="hhk-btn-box">
            <van-button type="default" color="#FF6633" block :to="{ path: '/storeAdmin-add' }"> 添加管理员 </van-button>
        </div>
    </div>
</template>

<script>
import { reqBusiness } from '../api/business';

export default {
    data() {
        return {
            phtone: '',
            adminList: [
                // { name: '测试', phone: '19113485587', role: '创建者', state: '1', type: 'create' },
                // { name: '测试', phone: '19113485587', role: '管理员', state: '1', type: 'manager' },
                // { name: '测试', phone: '19113485587', role: '管理员', state: '1', type: 'manager' },
                // { name: '测试', phone: '19113485587', role: '管理员', state: '1', type: 'manager' },
                // { name: '测试', phone: '19113485587', role: '管理员', state: '1', type: 'manager' }
            ]
        };
    },
    filters: {
        roleType: function(value) {
            if (value === 0) {
                return '管理员';
            } else if (value === 1) {
                return '创建者';
            } else {
                return '其他';
            }
        }
    },
    mounted() {
        this.phone = this.$globalData.phone1;
        this.getBusinessList();
    },
    methods: {
        // 获取商家管理员列表表
        getBusinessList() {
            reqBusiness({ phone: this.phone }).then(res => {
                console.log('商家管理员列表表:', res.data);
                this.adminList = res.data || [];
            });
        },
        onClick() {},
        // 前往编辑页
        onGoEditPage(item) {
            // const path = item.roleType === 0 ? '/store-creater-info' : '/storeAdmin-detail';
            this.$router.push({ path: '/store-creater-info', query: { item: JSON.stringify(item) } });
        }
    }
};
</script>

<style scoped lang="scss">
.billing-center-box {
    height: 100vh;
    background-color: #f5f5f5;
    display: flex;
    flex-direction: column;

    .store-admin-content {
        flex: 1;
        border-top: 1px solid #eeeeee;
        overflow: auto;

        .hhk-item {
            padding: 15px 10px;
            font-size: 14px;
            align-items: center;
            border-bottom: 1px solid #eeeeee;
            background-color: #ffffff;

            .left {
                flex: 1;

                .hhk-item-name {
                    font-size: 16px;
                    margin-right: 10px;
                }
            }

            .right .text {
                color: #ff6633;
            }
        }
        .hhk-item:active {
            background-color: #eeeeee;
        }
    }

    .hhk-btn-box {
        padding: 10px 10px;
        background-color: #ffffff;
        border-top: 1px solid #eeeeee;

        .van-button {
            font-size: 16px;
        }
    }
}
</style>
